import axios from "axios";

import Config from "src/config";

const v1_actionBuscarConfig = () => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/config/buscar-config`
    });
};
export default v1_actionBuscarConfig;
